if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/component/transitions.scss';
import '@assets/Scss/component/nav.scss';
import './tabs.scss';
import 'bootstrap/js/dist/tab';
